// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__Lu6fg","title":"NotFoundBlock_title__ukE45","wrapper":"NotFoundBlock_wrapper__9Sj5z","description":"NotFoundBlock_description__bXsdq"};